<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} transporte
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-8">
                  <label>Propietario<span class="required"></span></label>
                  <input type="text" id="client_owner" formControlName="owner" required class="form-control" autofocus>
                </div>
                <div class="form-group col-lg-4">
                  <label>N° Documento<span class="required"></span></label>
                  <div class="input-group">
                    <input type="text" id="client_document" formControlName="document" required numeric
                      class="form-control">
                  </div>
                </div>
                <div class="form-group col-lg-4">
                  <label>Nombre referencial <span class="f-s-11">(apelativo)</span></label>
                  <div class="input-group">
                    <input type="text" id="client_reference_name" formControlName="reference_name" class="form-control">
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>Celular <span class="required"></span></label>
                  <input type="text" formControlName="cellphone" numeric required class="form-control">
                </div>
                <div class="form-group col-lg-4">
                  <label>Descripción corta vehículo <span class="required"></span></label>
                  <div class="input-group">
                    <input type="text" id="client_vehicle_type" formControlName="vehicle_type" required
                      class="form-control">
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label><i class="fas fa-info-circle m-r-5" uib-tooltip="N° de asientos"></i>Capacidad asientos<span
                      class="required"></span></label>
                  <div class="input-group">
                    <input type="text" id="client_capacity" formControlName="capacity" numeric decimals="0" required
                      class="form-control">
                  </div>
                </div>
                <div class="form-group col-lg-4">
                  <label>Tipo vehículo
                    <button type="button" data-toggle="modal" data-target="#openExtendsVechicleType"
                      (click)="VehicletypeExtendsComponent.focused()"
                      class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                    </button>
                  </label>
                  <select class="form-control" id="vehicleTypeSelected" formControlName="vehicletype_id">
                    <option [ngValue]="null">Seleccione</option>
                    <option *ngFor="let item of vehicletypes" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-2">
                  <label>N° placa</label>
                  <div class="input-group">
                    <input type="text" id="client_license_plate" formControlName="license_plate" class="form-control">
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>Teléfono fijo</label>
                  <input type="text" formControlName="telephone" numeric class="form-control">
                </div>
                <div class="form-group col-lg-4">
                  <label>Correo electrónico</label>
                  <input type="email" formControlName="email" class="form-control">
                </div>
                <div class="form-group col-lg-6">
                  <label>Dirección</label>
                  <textarea formControlName="address" rows="2" class="form-control no-resize"></textarea>
                </div>
                <div class="form-group col-lg-6">
                  <label>Características vehículo</label>
                  <textarea formControlName="characteristic" rows="2" class="form-control no-resize"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<app-vehicletype-extends (onSubmitEvent)="extendsVehicleType($event)"></app-vehicletype-extends>
